import { jquery } from 'jquery';
import $ from 'jquery';

export default class Transition {
    constructor() {
        this.init();
    }

    init() {
        this.BREAK_POINT_PC = 'only screen and (min-width: 961px)';

        this.$window = $(window);
        this.scrolled_y = this.$window.scrollTop();
        this.bp = '';

        this.setEventHandler();
    }

    setEventHandler() {
        window.matchMedia(this.BREAK_POINT_PC).addListener(this.changeBreakPoint.bind(this));

        window.addEventListener('resize', () => {
            this.ww = this.$window.width();
            this.wh = this.$window.height();

            if (this.bp == 'sp') {
            }
        });

        window.addEventListener('scroll', () => {
            this.scrolled_y = this.$window.scrollTop();

            if (this.bp == 'sp') {
            }
        });

        this.changeBreakPoint();
    }

    changeBreakPoint() {
        if (window.matchMedia(this.BREAK_POINT_PC).matches) {
            this.bp = 'pc';

            this.pageTransition();
        } else {
            this.bp = 'sp';
        }
    }

    pageTransition() {
        $('a').on('click', function (event) {
            event.preventDefault();
            var linkUrl = $(this).attr('href');

            function action() {

                if (event.target.hasAttribute('target')) {
                    
                    var url = event.target.getAttribute('href');
                    event.target.setAttribute('rel', 'noopener nofollow');
                    window.open(url, '_blank');
                }
                else {
                    location.href = linkUrl;
                }
                
            }
            setTimeout(action, 500);
        });
    }
}
